/**
 * CalendarIcon/index.js
 * desc: calendar icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const CalendarSvg = <svg viewBox="0 0 18 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M13 0v2H5V0H3v2H2C.89 2 .01 2.9.01 4L0 18a2 2 0 002 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2h-1V0h-2zm1 11H9v5h5v-5zM2 18h14V7H2v11z" /></svg>;
const CalendarIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="calendar icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.calendar.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        { CalendarSvg }
    </IconButton>
);


export { CalendarSvg };
export default CalendarIcon;
